// src/ItemVariantPackageList.js ver 00 Jan 11 2026 11:20 pm SB119
import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useAuth } from './App';
import * as itemVariantPackageService from './api/itemVariantPackageService'; // Use new service
import PaginationBar2 from './PaginationBar2';

function ItemVariantPackageList() {
    // const { tenantId } = useParams(); // Get tenantId from URL
    const [itemVariantPackages, setItemVariantPackages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const auth = useAuth();

    // Pagination State
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(1);

    // Filter States
    const [statusFilter, setStatusFilter] = useState('Active'); // Default to 'Active'
    const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
    const statusDropdownRef = useRef(null);

    const tenantId = auth.userProfile?.SubsCoDocId;

    useEffect(() => {
        const fetchItemVariantPackages = async () => {
            if (!tenantId) {
                setError("Tenant ID missing.");
                setLoading(false);
                return;
            }
            setLoading(true);
            setError(null);
            try {
                const token = await auth.getIdToken();
                if (!token) {
                    setError("Authentication required. Please log in.");
                    setLoading(false);
                    return;
                }

                const response = await itemVariantPackageService.getItemVariantPackages(
                    tenantId,
                    token,
                    currentPage,
                    itemsPerPage,
                    statusFilter
                );
                setItemVariantPackages(response.packages); // Note: response contains 'packages'
                setTotalItems(response.totalItems);
                setTotalPages(response.totalPages);
            } catch (err) {
                console.error("Error fetching item variant packages from Cloud Function: ", err);
                setError(`Failed to load item variant packages: ${err.message}`);
            } finally {
                setLoading(false);
            }
        };
        fetchItemVariantPackages();
    }, [auth, tenantId, currentPage, itemsPerPage, statusFilter]);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const handleLimitChange = (newLimit) => {
        setItemsPerPage(newLimit);
        setCurrentPage(1); // Reset to first page when limit changes
    };

    // Generic toggle for any dropdown
    const toggleDropdown = (setter) => {
        setter(prev => !prev);
    };

    // Filter change handlers
    const handleStatusFilterChange = (filter) => {
        setStatusFilter(filter);
        setCurrentPage(1);
        setIsStatusDropdownOpen(false);
    };


    // Close all dropdowns when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target)) {
                setIsStatusDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    if (loading) return <p>Loading item variant packages...</p>;
    if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;
    if (!tenantId) return <p style={{ color: 'orange' }}>Tenant ID is required to manage item variant packages.</p>;


    return (
        <div>
            <div className="page-header">
                <h2>Item Variant Packages</h2>
                {/* <Link to={`/item-variant-packages/add/${tenantId}`} className="btn secondary">Add New Package</Link> */}
                <Link to={`/item-variant-packages/add`} className="btn secondary">Add New Package</Link>
            </div>

            <PaginationBar2
                currentPage={currentPage}
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                totalItems={totalItems}
                onPageChange={handlePageChange}
                onLimitChange={handleLimitChange}
            />

            <table>
                <thead>
                    <tr>
                        <th>VrtPkgNm</th> {/* Renamed */}
                        <th>SKU</th>
                        <th>UPC</th>
                        <th>Rating</th> {/* Renamed */}
                        <th
                            className="dropdown-th"
                            onClick={() => toggleDropdown(setIsStatusDropdownOpen)}
                            ref={statusDropdownRef}
                            title="Click to Filter"
                        >
                            Status {statusFilter !== 'no-filter' && `(${statusFilter})`}
                            {isStatusDropdownOpen && (
                                <ul className="dropdown-menu">
                                    <li onClick={() => handleStatusFilterChange('no-filter')}>&lt;no filter&gt;</li>
                                    <li onClick={() => handleStatusFilterChange('Active')}>Active</li>
                                    <li onClick={() => handleStatusFilterChange('Not-Active')}>Not-Active</li>
                                </ul>
                            )}
                        </th>
                        {/* <th>Date Added</th>
                        <th>Date Last Modified</th> */}
                    </tr>
                </thead>
                <tbody>
                    {itemVariantPackages.map(pkg => (
                        <tr key={pkg.id}>
                            <td>
                                <Link to={`/item-variant-packages/details/${pkg.id}`}> {/* Link to show all details */}
                                    {pkg.ItemVariantPackageName}
                                </Link>
                            </td>
                            <td>{pkg.SKU}</td>
                            <td>{pkg.UPC}</td>
                            <td>{pkg.ChefsRating}</td>
                            <td>{pkg.Status}</td>
                            {/* <td>{pkg.DateAdded ? new Date(pkg.DateAdded._seconds * 1000).toLocaleString() : 'N/A'}</td>
                            <td>{pkg.DateLastModified ? new Date(pkg.DateLastModified._seconds * 1000).toLocaleString() : 'N/A'}</td> */}
                        </tr>
                    ))}
                </tbody>
            </table>

            <PaginationBar2
                currentPage={currentPage}
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                totalItems={totalItems}
                onPageChange={handlePageChange}
                onLimitChange={handleLimitChange}
            />
        </div>
    );
}

export default ItemVariantPackageList;